import React from 'react';
import './loader.css';

function Loader() {
  return (
    <div className="loader" role="status" aria-label="Loading">

      {/* Corner accent brackets */}
      <div className="loader-corner loader-corner--tl" />
      <div className="loader-corner loader-corner--tr" />
      <div className="loader-corner loader-corner--bl" />
      <div className="loader-corner loader-corner--br" />

      {/* Logo */}
      <div className="loader-logo">Alchemy Mix</div>

      {/* Dual-ring spinner with center dot */}
      <div className="loader-ring-wrap">
        <div className="loader-dot" />
      </div>

      {/* Sliding progress bar */}
      <div className="loader-bar-wrap">
        <div className="loader-bar" />
      </div>

      {/* Status text */}
      <div className="loader-status">Processing</div>

    </div>
  );
}

export default Loader;